"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Symbol = Symbol;
var _symbols = require("@a1s/symbols");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Main component
// -------------------------------------------------------------------------------------------------

function Symbol({
  name,
  ...rest
}) {
  const Component = _symbols.dictionary[name];
  return /*#__PURE__*/_react.default.createElement(Component, rest);
}